import React from 'react';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../app/store";
import { authenticateUserFromStorage } from "../../../../app/features/sessions/sessionSlice";
import { getMergedAudioFile } from "../../../../app/features/sessions/sessionProjectManagementPlayer/sliceProjectManagementPlayer";
import { useParams } from "react-router-dom";
import mixProjectContentsIcon from '../../../../../src/app/assets/mix-contents-icon.png';
import { createSilentAudioBuffer, fetchAudioBuffer } from "./BufferToWave";
import Crunker from 'crunker';
import LoadingModal from '../../../../app/components/modal/loadingModal/LoadingModal';
import audioBufferToWav from 'audiobuffer-to-wav';
import './mixProjectContents.css';
import { toast } from "react-toastify";
import { getProjectContentsToMix, mixSelectedProjectContents } from '../../../../app/features/sessions/projectsManagement/sessionManageProject';


export default function MixProjectContents({setMixedAudioUrl}:any){
    const authHeaders = useSelector((state: RootState) => state.session.authHeaders);
    const userValidated = useSelector((state: RootState) => state.session.loggedIn);
    const currentUser = useSelector((state: RootState) => state.session.currentUser);
    const currentProject = useSelector((state: RootState) => state.sessionProjectPlayerManagement.currentProject.project);
    const projectContentsSelectedToMix = useSelector((state: RootState) => state.sessionManageProjectContents.projectContentsToMix);
    const projectContentSelectedList = useSelector((state: RootState) => state.sessionManageProjectContents.projectContentSelectedList);
    const dispatch = useDispatch<AppDispatch>();
    const { userNicknameRoute, projectIdRoute } = useParams();
    const loading = useSelector((state: RootState) => state.sessionProjectPlayerManagement.loading);
    const mergedAudioUrl = useSelector((state: RootState) => state.sessionProjectPlayerManagement.mergedAudioUrl);
    const loadingSelection = useSelector((state: RootState) => state.sessionProjectPlayerManagement.loadingSelection);

    useEffect(() => {
        async function authenticateUser() {
            if (!userValidated) {
              await dispatch(authenticateUserFromStorage());
            }
        }

        async function handleProjectContentsToMix() {
            await dispatch(getProjectContentsToMix({authHeaders: authHeaders, 
                                                                     userNickname: userNicknameRoute, 
                                                                     projectId: projectIdRoute, 
                                                                     listProjectContentsId: projectContentSelectedList}));
        }
        
        authenticateUser();
        handleProjectContentsToMix();
    },[])
      
    
      async function handleProjectContentsToMix() {
        console.log('[Mix] handleProjectContentsToMix iniciado');
        console.log('[Mix] projectIdRoute:', projectIdRoute);
        console.log('[Mix] currentUser:', currentUser?.id);
        console.log('[Mix] projectContentSelectedList:', projectContentSelectedList);

        setMixedAudioUrl('');

        if (projectIdRoute && projectContentSelectedList && currentUser){

            console.log('[Mix] A enviar pedido de mixagem...');
            const response = await dispatch(mixSelectedProjectContents({projectId: parseInt(projectIdRoute),
                                                                        userId: currentUser.id,
                                                                        idListToMix: projectContentSelectedList}))

            console.log('[Mix] mixSelectedProjectContents status:', response.meta.requestStatus);
            console.log('[Mix] mixSelectedProjectContents payload:', response.payload);

            if (response.meta.requestStatus == "rejected" && projectContentSelectedList.length == 1){
                console.warn('[Mix] Mix rejeitado (1 conteúdo):', response.payload);
                toast.warning(response.payload.data.error);
            }

            if (response.meta.requestStatus == "fulfilled" || (response.meta.requestStatus == "rejected" && projectContentSelectedList.length == 1)){

                console.log('[Mix] A buscar merged_audio_file...');
                const response = await dispatch(getMergedAudioFile({ projectId: parseInt(projectIdRoute) }));

                console.log('[Mix] getMergedAudioFile status:', response.meta.requestStatus);
                console.log('[Mix] getMergedAudioFile payload:', response.payload);

                if (response.meta.requestStatus == "fulfilled" || (response.meta.requestStatus == "rejected" && projectContentSelectedList.length == 1)) {
                    const url = response.payload['merged_file_url'];
                    console.log('[Mix] merged_file_url recebido:', url);
                    setMixedAudioUrl(url);
                    return;
                }
            }
        } else {
            console.warn('[Mix] Condição não satisfeita — projectIdRoute:', projectIdRoute, 'currentUser:', currentUser?.id, 'selectedList:', projectContentSelectedList);
        }
      }
      
    
    return (
        <>
            {loading == true?
                
                <LoadingModal/>
                :
                <div id='container-mix-project-contents'>
                    { projectContentSelectedList.length > 0 ?
                            <button id='mix-contents-button'
                                onClick = {handleProjectContentsToMix}>
                                <img src = {mixProjectContentsIcon} style={{ width: "35px", height: "35px" }}></img>
                            </button>
                        :null
                    }
                 </div>
             }
        </>
    )
}